module.exports = __webpack_public_path__ + "img/question_white_icon.db214ad3.svg";